import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import RewardGlyph from "../../assets/RewardGlyph";
import Tile from "../../assets/Tile";
import TileGlyph from "../../assets/TileGlyph";
import type { Reward } from "../../types";
import getTierLevel from "../TierCard/getTierLevel";
import { REWARD_TILE } from "./rewardMeta";

type Props = {
  reward: Reward;
};

const RewardTile: FC<Props> = ({ reward }) => {
  const {
    state: { tiers, currentTier, currentPoints },
  } = useRewardCenter();
  const tier = tiers.find((item) => item.id === currentTier);

  if (reward.state === "locked") {
    return (
      <Tile type="link" size="40">
        <RewardGlyph name="lock" />
      </Tile>
    );
  }

  const type = REWARD_TILE[reward.type];
  const level = tier ? getTierLevel(tier, currentPoints).level : undefined;

  return (
    <Tile type={type} size="40">
      <TileGlyph type={type} level={level} tierName={tier?.name} />
    </Tile>
  );
};

export default RewardTile;
